import ContainerWithLogo from './ContainerWithLogo';

export default ContainerWithLogo;
